<template lang="pug">
  v-container.pa-0(fluid)
    v-snackbar(v-model="showSnackBar" :color="snackbarColor") {{ snackBarMessage }}
      template(v-slot:action="{ attrs }")
        v-btn.justify-end(fab text v-bind="attrs" @click="showSnackBar = false")
          v-icon fal fa-times-circle
    v-card.elevation-0
      v-card-title.title Rozvoz
      v-card-text
        v-row.ma-0
          v-col.pa-0(md="6" cols="12")
            v-select(v-if="businessesList && businessesList.length > 2"
              v-model="selectedBusiness"
              append-icon="fas fa-chevron-down"
              outlined
              item-text="name"
              itev-value="id"
              return-object
              :items="businessesList"
              :label="$t('businessPage.editBusinessDialogTitle') "
              @change="onSelectedBusinessChange")
            v-text-field.font-weight-bold.pa-0(v-else-if="businessesList[0] " :label="$t('businessPage.editBusinessDialogTitle') " outlined readonly v-model="businessesList[0].name")
        v-row.ma-0
          v-col.pa-0(md="6" cols="12")
            v-select(v-if="getFilteredCustomers && getFilteredCustomers.length > 1" ref="customerSelector"
              v-model="selectedCustomer"
              append-icon="fas fa-chevron-down"
              outlined
              item-text="name"
              itev-value="id"
              return-object
              :items="getFilteredCustomers"
              :label="$t('dashboardPage.customer') "
              @change="onSelectedCustomerChange")
            v-text-field.font-weight-bold.pa-0(v-else-if="getFilteredCustomers && getFilteredCustomers[0] " outlined label="Zakaznik"  readonly v-model="getFilteredCustomers[0].name")
        v-row.ma-0
          v-col.text-start(cols="2" md="1")
            v-btn.text-end.pl-md-4(@click="onPrevDayClick" icon)
              v-icon.text-start fas fa-chevron-double-left
          v-col.text-h5.font-weight-bold.text-center(cols="8" md="4")
            span.pt-2 {{getDayTitle}} {{getFormattedDate}}
          v-col.text-end(cols="2" md="1")
            v-btn.text-end(@click="onNextDayClick" icon)
              v-icon.text-end fas fa-chevron-double-right
        v-row.ma-0(no-gutters )
          v-col.pa-0.pr-2.pl-md-2(cols="12" md="6"  v-if="selectedCustomer && reservationsSlotsData.length > 0")
            v-card.elevation-4(flat :color="getCardStyle")
              v-card-title.title.font-weight-bold.title-overflow-ellipses {{selectedCustomer ? selectedCustomer.name : ''}}
              v-card-text
                v-row.ma-0(no-gutters )
                  v-col.pl-4(cols="8" md="7")
                    span.badge-container.mr-8(v-for="(item,idx) in reservationsSlotsData" :key="idx")
                      v-btn-toggle(:v-model="foodItemTitle" multiple fab)
                        v-btn.title.py-0(fab small @click="onDetailFoodItemClick(item,idx)"  ) {{item.code}}
                      v-badge.custom-badge.top-left(right bordered color="error" overlap :content="item.count")
                        span
                      v-badge.custom-badge.top-right(left bordered color="success" overlap :content="item.totalAmount")
                        span
                  v-spacer
                  v-col.text-end.mt-2(md="5" cols="4")
                    v-btn.text-end.ml-3(@click="deliveredFoodItemClick" color="#81ccc5" :disabled="!isFoodDelivered" :loading="deliveredLoading")
                      v-icon fas fa-cookie-bite
                      span.pl-1(v-if="$vuetify.breakpoint.lgAndUp")  {{ $t('dashboardPage.deliveredFood') }}

              v-row.ma-0.ml-md-4(v-for="(c,idx) in foodItemTitleList", :key="idx")
                v-col.style(md="2" cols="3")
                  v-row.ma-0.fill-height(justify="center" align="center" )
                    v-col.text-center.text-h5.pr-2.py-0.border-col-component(cols="12" md="12" :style="{'color' : 'grey'}") {{c.code}}
                v-col.text-start.text-wrap.px-0(md="8" cols="6")
                  v-row.ma-0.fill-height(justify="center" align="center" )
                    v-col.text-start.py-0.text-wrap.pa-0(cols="12" md="12") {{c.name}}
                v-col.text-start.pa-0(md="2" cols="3")
                  v-row.ma-0.fill-height(justify="center" align="center" )
                    v-col.text-end.text-h5.pr-2.py-0(cols="12" md="12") {{c.count}}
              v-card-text.pa-0
                v-list.pt-2(dense )
                  v-list-item(v-for="(item,idx) in boarders" :key="idx" )
                    v-list-item-content(dense )
                      v-row.ma-0(no-gutters :style="foodDeliveredColor" v-if="item.status !== 'canceled'")
                        v-col.text-h5(cols="12" md="5" ) {{item.firstName}} {{item.familyName}}
                        v-col.text-h5.text-start(cols="5" v-if="$vuetify.breakpoint.mdAndUp" )
                          v-badge.ml-4.mt-2(bordered color="success" overlap :content="i.amount" v-for="(i,idx) in item.reservedOffers" :key="idx")
                            v-btn.title.ml-2.mt-0(small disabled) {{i.code}}
                        v-col.text-h5.text-start(cols="9" v-if="$vuetify.breakpoint.smAndDown" )
                          v-badge.ml-4.mt-1(bordered color="success" overlap :content="i.amount" v-for="(i,idx) in item.reservedOffers" :key="idx")
                            v-btn.title.elevation-0.ml-2.mt-0( small disabled) {{i.code}}
                        v-col.pa-0.text-end.pr-1(md="2" cols="2")
                          v-btn(icon @click="isFoodDeliveredClick(item)" :disabled="isFoodDeliveredOffer(item)" :loading="deliveredLoading")
                            v-icon(:color="getColor(item)" ) {{getIcon(item)}}
                      v-row.ma-0.mb-4.chip-overflow()
                        v-col.pt-0(cols="12" )
                          v-expansion-panels.boarder-alert-notice-style.mt-8.ma-0(accordion v-model="open"  v-if="item && item.boarderNote && item.boarderNote !== null" )
                            v-expansion-panel.ma-0(v-ripple="false" )
                              v-expansion-panel-header.expansion-panel-header-min-height.pl-0.chip-overflow.pt-4( :style="{'white-space': 'pre-wrap'}" expand-icon="fas fa-angle-double-down"  )
                                  v-col.px-3(cols="auto")
                                    v-icon(color="primary" ) fas fa-info-circle
                                  v-col.chip-overflow.pa-0.pr-3
                                    span.text-start.chip-overflow.pb-1(v-if="open !== 0") {{item.boarderNote}}
                              v-expansion-panel-content(:style="{'white-space': 'pre-wrap'}" ) {{item.boarderNote}}
                        v-col.ma-0(v-if="isDivider(idx) && item.boarderNote && item.boarderNote !== null" cols="12")
                          v-divider



          v-col.text-center.font-weight-bold(cols="12" md="6" v-else-if="!reservationsDataLoading") {{selectedCustomer ?  $t('dashboardPage.noFoodMenuOrderForCustomer',{customer: selectedCustomer.name}) : ''}}
        v-row.ma-0(v-if="reservationsDataLoading")
          v-col(cols="6")
            v-skeleton-loader( type="list-item-three-line")


</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Watch} from 'vue-property-decorator'
import moment from "moment/moment";
import axios from "@/plugins/axios";
import _, {indexOf} from "lodash";
import CustomerModel from "@/model/customer/CustomerModel";
import BoardersModel from "@/model/boarder/BoardersModel";
import DashboardReservations from "@/model/reservation/DashboardReservations";
import Businesses from "@/model/business/Businesses";
import {
  BusinessResponse,
  MenuGroupSlotsResponse,
  ReservationsSlotsDataResponse,
  ReservedOffersResponse,
  TopMenuGroupResponse
} from "@/types/service-response";

interface ReservationsSlotsData {
  code: string,
  count: number,
  name: string,
  id: number,
  totalAmount: number
}

@Component
export default class BusinessReservationSummary extends Vue {

  private actuallyDate: string = ''
  private boarders: BoardersModel[] = []
  private businessesList: BusinessResponse[] = []
  private reservationsSlotsData: ReservationsSlotsData[] = []
  private foodItemTitle: string = ''
  private reservationsData: DashboardReservations[] = []
  private data: Map<string, {
    title: string,
    value: number,
    food: string,
    status: boolean,
    icon: string,
    totalPortion: number
  }[]> = new Map();
  private business: Businesses | null = null
  private date: string = moment().format('YYYY-MM-DD')
  private customers: CustomerModel[] = []
  private selectedCustomer: CustomerModel | null = null
  private selectedBusiness: BusinessResponse | null = null
  private currentDate: string = ''
  private foodItemTitleList: ReservationsSlotsDataResponse[] = []
  private reservationsDataLoading: boolean = false
  private showSnackBar: boolean = false
  private snackbarColor: string = ''
  private snackBarMessage: string | null = null
  private deliveredLoading = false
  private open: number | null = null


  get getDayTitle(): string {
    if (this.actuallyDate) {
      if (this.actuallyDate === moment().format('YYYY-MM-DD')) {
        return this.$t('dashboardPage.today').toString()
      } else if (this.actuallyDate === moment().add(1, 'day').format('YYYY-MM-DD')) {
        return this.$t('dashboardPage.tomorrow').toString()
      } else if (this.actuallyDate === moment().subtract(1, 'day').format('YYYY-MM-DD')) {
        return this.$t('dashboardPage.yesterday').toString()
      } else {
        return ''
      }
    } else {
      return ''
    }
  }

  get getCardStyle(): string {
    if (this.actuallyDate && this.actuallyDate === moment().format('YYYY-MM-DD')) {
      return '#E0F2F1'
    } else {
      return '#f3efef'
    }
  }

  get foodDeliveredColor(): string {
    if (this.isFoodDelivered) {
      return '#E0F2F1'
    } else {
      return ''
    }
  }

  get isFoodDelivered(): boolean {
    return !!this.boarders.find((item: BoardersModel) => item.status === 'active')
  }

  isFoodDeliveredOffer(item: BoardersModel): boolean {
    if (item.status === 'delivered') {
      return true
    } else {
      return false
    }
  }

  async deliveredFoodItemClick(): Promise<void> {
    let promiseList: Promise<void>[] = []
    let payload: BoardersModel | null = null
    this.boarders.forEach((item: BoardersModel) => {
      item.idList.forEach((i: any) => {
        payload = i
        promiseList.push(this.foodDelivered(payload, false))
      })
    })
    try {
      await Promise.all(promiseList)
      this.showSnackBar = true
      this.snackbarColor = 'success'
      this.snackBarMessage = this.$t('dashboardPage.reservationWasAlreadyDeliveredMessage').toString()
    } catch (e) {
      this.showSnackBar = true
      this.snackbarColor = 'error'
      this.snackBarMessage = this.$t('dashboardPage.snackbarErrorSaveMessage').toString()
    } finally {
      this.deliveredLoading = false
    }
    await this.fetchReservationData()
  }

  getColor(item: BoardersModel): string {
    if (item && item.status === 'delivered') {
      return '#8fa2c3'
    } else {
      return '#81ccc5'
    }
  }

  getIcon(item: any): string {
    if (item && item.status === 'delivered') {
      return 'fas fa-cookie-bite'
    } else if (item && item.status === 'active') {
      return 'fas fa-cookie'
    } else {
      return ''
    }
  }

  get getFormattedDate() {
    if (this.currentDate) {
      return moment(this.currentDate, 'YYYY-MM-DD').format('D.M.YYYY')
    } else {
      return moment().format('D.M.YYYY')
    }
  }

  getBusinessFilteredData(value: any, item: any): any {
    return value.filter((i: any) => i.business === item.id)
  }

  get getFilteredCustomers(): CustomerModel[] {
    if (this.selectedBusiness) {
      return this.customers.filter((item: CustomerModel) => item.businesses.find((i: any) => i.id === this.selectedBusiness!.id))
    } else {
      return []
    }
  }

  onSelectedBusinessChange(): void {
    this.selectedCustomer = this.getFilteredCustomers[0] ? this.getFilteredCustomers[0] : null
    this.filterData()
  }

  onSelectedCustomerChange(): void {
    this.filterData()
  }

  filterData(): void {
    this.reservationsSlotsData = this.calculateReservationsSlotsData()
    this.boarders = []

    this.reservationsData.forEach((item: DashboardReservations) => {

      if (this.selectedCustomer && item.customer.id === this.selectedCustomer.id) {
        let reservedOffers: any[] = []
        item.reservedOffers.forEach((i: any) => {

          let tmgOrder: number = 1
          let smgOrder: number = 1
          let order: number = 1
          item.topMenuGroup.subMenuGroups.forEach((n: any) => {
            n.menuGroupSlots.forEach((m: any) => {
              if (m.id === i.dailyMenuOffer.menuGroupSlot.id) {
                tmgOrder = item.topMenuGroup.order
                smgOrder = n.order
                order = m.order
              }
            })
          })

          reservedOffers.push({
            tmgOrder: tmgOrder,
            smgOrder: smgOrder,
            order: order,
            code: i.dailyMenuOffer.menuGroupSlot.code,
            amount: i.amount
          })
        })

        reservedOffers = _.orderBy(reservedOffers, ['tmgOrder', 'smgOrder', 'code', 'order',])
        const foundBoarder: BoardersModel | undefined = this.boarders.find((boarder: BoardersModel) => boarder.boarderId === item.boarder.id)
        if(foundBoarder){
          reservedOffers.forEach((offer: any) => {
            foundBoarder.reservedOffers.push(offer)
          })
          foundBoarder.idList.push(item.id)
        } else {
          this.boarders.push({
            boarderId: item.boarder.id,
            firstName: item.boarder.person.firstName,
            familyName: item.boarder.person.familyName,
            idList: [item.id],
            status: item.status.name,
            reservedOffers: reservedOffers,
            boarderNote: item.boarderNote && item.boarderNote !== null ? item.boarderNote : null
          })
        }
      }
    })
  }

  isDivider (item: any) {
    if (item <= 0) {
      return true
    } else {
      return false
    }
  }

  calculateReservationsSlotsData(): ReservationsSlotsData[] {
    interface MenuGroupSlotInfo {
      menuGroupSlot: MenuGroupSlotsResponse
      topMenuGroup: TopMenuGroupResponse
      menuGroup: TopMenuGroupResponse
      name: string
      amount: number
    }

    interface AggregatedMenuGroupSlotInfo {
      menuGroupSlot: MenuGroupSlotsResponse
      topMenuGroup: TopMenuGroupResponse
      menuGroup: TopMenuGroupResponse
      totalAmount: number
      name: string
      count: number
    }

    const findMenuGroupOfSlot = _.memoize((menuGroupSlot: MenuGroupSlotsResponse): TopMenuGroupResponse | null => {
      return _.chain(this.reservationsData)
        .flatMap(reservation => reservation.topMenuGroup.subMenuGroups)
        .find(subMenuGroup =>
          _.some(subMenuGroup.menuGroupSlots, {id: menuGroupSlot.id})
        )
        .value() || null
    }, (menuGroupSlot) => menuGroupSlot.id)

    const allMenuGroupSlots: MenuGroupSlotInfo[] = _.chain(this.reservationsData)
      .filter(reservation => reservation.customer.id === this.selectedCustomer!.id)
      .filter(reservation => reservation.status.name !== 'canceled')
      .flatMap(reservation =>
        reservation.reservedOffers.map(reservedOffer => ({
          menuGroupSlot: reservedOffer.dailyMenuOffer.menuGroupSlot,
          topMenuGroup: reservation.topMenuGroup,
          menuGroup: findMenuGroupOfSlot(reservedOffer.dailyMenuOffer.menuGroupSlot)!,
          name: reservedOffer.dailyMenuOffer.referenceFoodItem.title,
          amount: reservedOffer.amount
        }))
      )
      .value();

    // aggregate slots
    // count total amount and number of reservations for each slot
    // slots with the same menuGroupSlot are aggregated into one object
    const aggregatedSlots: AggregatedMenuGroupSlotInfo[] = _.chain(allMenuGroupSlots)
      .groupBy('menuGroupSlot.id')
      .map((group) => {
        // Assuming all objects in the group have the same menuGroupSlot, topMenuGroup, and menuGroup
        const representativeSlot = group[0];

        return {
          menuGroupSlot: representativeSlot.menuGroupSlot,
          topMenuGroup: representativeSlot.topMenuGroup,
          menuGroup: representativeSlot.menuGroup,
          name: representativeSlot.name,
          totalAmount: _.sumBy(group, 'amount'),
          count: group.length
        }
      })
      .value()

    // group and sort aggregated slots
    // groupings: topMenuGroup -> menuGroup -> menuGroupSlot
    const groupedAndSortedAggregatedSlots = _.chain(aggregatedSlots)
      .groupBy(slot => slot.topMenuGroup.id)
      .mapValues(groupByTopGroup =>
        _.chain(groupByTopGroup)
          .groupBy(slot => slot.menuGroup.id)
          .mapValues(groupByMenuGroup =>
            _.sortBy(groupByMenuGroup, ['menuGroupSlot.order'])
          )
          .value()
      )
      .value();

    // flatten grouped and sorted aggregated slots so it complies with original data structure
    return _.flatMap(groupedAndSortedAggregatedSlots, topGroup =>
      _.flatMap(topGroup, menuGroup =>
        _.map(menuGroup, (slot: AggregatedMenuGroupSlotInfo) => {
          return {
            code: slot.menuGroupSlot.code,
            count: slot.count,
            name: slot.name,
            id: slot.menuGroupSlot.id,
            totalAmount: slot.totalAmount
          }
        })
      )
    )
  }

  onNextDayClick(): void {
    this.currentDate = moment(this.actuallyDate, 'YYYY-MM-DD').add(1, 'day').format('YYYY-MM-DD')
    this.boarders = []
    this.foodItemTitleList = []
    this.reservationsSlotsData = []
    this.fetchReservationData()
    this.actuallyDate = this.currentDate
  }

  onPrevDayClick(): void {
    this.currentDate = moment(this.actuallyDate, 'YYYY-MM-DD').subtract(1, 'day').format('YYYY-MM-DD')
    this.boarders = []
    this.foodItemTitleList = []
    this.reservationsSlotsData = []
    this.fetchReservationData()
    this.actuallyDate = this.currentDate
  }

  async isFoodDeliveredClick(item: any): Promise<void> {
    let promiseList: Promise<void>[] = []
    let payload: any | null = null

    item.idList.forEach((i: number) => {
      payload = i
      promiseList.push(this.foodDeliveredSingle(payload, false))
    })
    try {
      await Promise.all(promiseList)
      this.showSnackBar = true
      this.snackbarColor = 'success'
      this.snackBarMessage = this.$t('dashboardPage.reservationWasAlreadyDeliveredMessage').toString()
    } catch (e) {
      this.showSnackBar = true
      this.snackbarColor = 'error'
      this.snackBarMessage = this.$t('dashboardPage.snackbarErrorSaveMessage').toString()
    } finally {
      this.deliveredLoading = false
    }
    await this.fetchReservationData()
  }

  async foodDeliveredSingle(item: any, show: boolean): Promise<void> {
    const payload: number = item
    this.deliveredLoading = true
    try {
      await axios.put(`/api/food-ordering/offer-reservation-admin-delivery/${payload}`)
      if (show) {
        this.showSnackBar = true
        this.snackbarColor = 'success'
        this.snackBarMessage = this.$t('dashboardPage.reservationWasAlreadyDeliveredMessage').toString()
      }
    } catch (e) {
      if (show) {
        this.showSnackBar = true
        this.snackbarColor = 'error'
        this.snackBarMessage = this.$t('dashboardPage.snackbarErrorSaveMessage').toString()
      }
    } finally {
      if (show) {
        this.deliveredLoading = false
      }
    }
  }


  async foodDelivered(item: any, show: boolean): Promise<void> {
    const payload: number = item
    this.deliveredLoading = true
    try {
      await axios.put(`/api/food-ordering/offer-reservation-admin-delivery/${payload}`)
      if (show) {
        this.showSnackBar = true
        this.snackbarColor = 'success'
        this.snackBarMessage = this.$t('dashboardPage.reservationWasAlreadyDeliveredMessage').toString()
      }
    } catch (e) {
      if (show) {
        this.showSnackBar = true
        this.snackbarColor = 'error'
        this.snackBarMessage = this.$t('dashboardPage.snackbarErrorSaveMessage').toString()
      }
    } finally {
      if (show) {
        this.deliveredLoading = false
      }
    }
  }

  async fetchCustomers(): Promise<void> {
    try {
      const response = await axios.get(`/api/customer`)


      this.customers = _.orderBy(response.data, 'order')

      let customerList: any[] = []
      this.customers.forEach((item: CustomerModel) => {
        item.businesses.forEach((i: BusinessResponse) => {
          this.businessesList.push(i)
        })

      })

      this.selectedBusiness = this.businessesList[0] ? this.businessesList[0] : null
      this.selectedCustomer = this.getFilteredCustomers[0] ? this.getFilteredCustomers[0] : null

    } catch (e) {
      this.showSnackBar = true
      this.snackbarColor = 'error'
      this.snackBarMessage = this.$t('errors.fetchDataError').toString()
    }
  }

  onDetailFoodItemClick(item: ReservationsSlotsDataResponse, index: number) {
    if (!this.foodItemTitleList.includes(item)) {
      this.foodItemTitleList.push(item)
    } else {
      this.foodItemTitleList.splice(index, 1)
    }
  }

  async fetchReservationData(): Promise<void> {
    const start_date = this.currentDate
    const end_date = this.currentDate

    try {
      this.reservationsDataLoading = true
      this.boarders = []
      this.reservationsSlotsData = []
      const response = await axios.get('/api/food-ordering/offer-reservation?date[before]=' + start_date + '&date[after]=' + end_date)

      this.reservationsData = response.data
      this.filterData()
    } catch (e) {
      this.showSnackBar = true
      this.snackbarColor = 'error'
      this.snackBarMessage = this.$t('errors.fetchDataError').toString()
    } finally {
      this.reservationsDataLoading = false
    }
  }

  async mounted(): Promise<void> {
    this.currentDate = moment().format('YYYY-MM-DD')
    await this.fetchCustomers()
    await this.fetchReservationData()
    this.actuallyDate = this.$route.params.date ? this.$route.params.date : moment().format('YYYY-MM-DD')

  }
}
</script>

<style lang="stylus" scoped>
.expansion-panel-header-min-height
  height 20px !important

.title-overflow-ellipses
  display block
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis !important

.chip-overflow
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis !important
  padding-top 6px

.boarder-alert-notice-style
  border 1px solid #1976d2

  >>> .v-alert__icon.v-icon
    color #1976d2

.badge-container
  display inline-block
  position relative

.custom-badge
  position absolute

.top-left
  top 0
  left 0

.top-right
  top 0
  right 0

.toolbar-style
  background-color #1051a9

.border-col-component
  border white solid
  border-bottom-right-radius 10px
  border-bottom-left-radius 10px
  border-top-left-radius 10px
  border-top-right-radius 10px
  background-color white

.border-component
  padding-top 20px

.style
  max-width 80px
  max-height auto


</style>